var exports = {
  "yl": "modal-STNPa",
  "qw": "scrolling-STNPa",
  "ZS": "contentCnt-STNPa",
  "Qs": "content-STNPa",
  "QH": "bgActive-STNPa",
  "XV": "topBar-STNPa",
  "xv": "controlButtons-STNPa",
  "pR": "bottomBar-STNPa",
  "ZC": "bgColor-STNPa",
  "Bg": "bgImg-STNPa",
  "sQ": "bottom-STNPa",
  "yy": "fullwidth-STNPa",
  "Hw": "mobile-STNPa",
  "vd": "noTop-STNPa",
  "FY": "noBottom-STNPa",
};

module.exports = exports;
